import React, { Component } from "react";
import moment from "moment";

import { translate } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

import "./ItinerariesPrintable.css";

class ItinerariesPrintable extends Component {
  state = {};

  searchItineraries = ({
    match: {
      params: { from, to, sdate, edate, language },
    },
  }) => {
    this.setState({ loading: true });
    fetch(`${FETCH_URL}/proxy.php?ws=5a84eaef340463398015c41e8361c199`, {
      method: "POST",
      body: JSON.stringify({
        outgoingLocationCode: `${from === "ALL" ? "" : from}`,
        incomingLocationCode: `${to === "ALL" ? "" : to}`,
        outgoingDate: `${sdate}`,
        incomingDate: `${edate}`,
        languageCode: `${language}`,
        includeEvents: true,
        dayRange: 0,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({
          loading: false,
          outgoingTrips: json.outgoingTrips,
          incomingTrips: json.incomingTrips,
          outgoingDestinationTrips: json.outgoingDestinationTrips,
          incomingDestinationTrips: json.incomingDestinationTrips,
        });
      });
  };

  componentDidMount() {
    this.searchItineraries(this.props);
  }

  renderTable = (trips, index) => {
    const firstWithTrips = trips.find((trip) => trip.trips.length);
    const {
      match: {
        params: { language },
      },
    } = this.props;
    if (firstWithTrips) {
      return (
        <div className="printable-container" key={index}>
          <span>
            {firstWithTrips.trips[0].departureLocation.name}
            {" - "}
            {firstWithTrips.trips[0].arrivalLocation.name}
          </span>
          <table>
            <thead>
              <tr>
                <th className="header">{translate(language, "Date")}</th>
                <th className="header">{translate(language, "Departure")}</th>
                <th className="header">{translate(language, "Arrival")}</th>
                <th className="header">{translate(language, "Company")}</th>
                <th className="header">{translate(language, "Vessel")}</th>
                <th className="header">
                  {translate(language, "Departure Time")}
                </th>
                <th className="header">
                  {translate(language, "Arrival Time")}
                </th>
              </tr>
            </thead>
            <tbody>
              {trips.map((itinerary) => {
                return itinerary.trips.map((trip, index) => {
                  return (
                    <tr key={index}>
                      <td>{itinerary.tripDate}</td>
                      <td>{trip.departureLocation.name}</td>
                      <td>{trip.arrivalLocation.name}</td>
                      <td>{trip.company.name}</td>
                      <td>{trip.vessel.name}</td>
                      <td>{moment(trip.departureDateTime).format("HH:mm")}</td>
                      <td>{moment(trip.arrivalDateTime).format("HH:mm")}</td>
                    </tr>
                  );
                });
              })}
            </tbody>
          </table>
        </div>
      );
    }
  };

  render() {
    const {
      outgoingTrips,
      incomingTrips,
      outgoingDestinationTrips,
      incomingDestinationTrips,
      loading,
    } = this.state;
    if (loading) {
      return <div className="loader">loading...</div>;
    } else {
      return (
        <div className="printable">
          {outgoingTrips &&
            outgoingTrips.length > 0 &&
            this.renderTable(outgoingTrips)}
          {incomingTrips &&
            incomingTrips.length > 0 &&
            this.renderTable(incomingTrips)}
          {outgoingDestinationTrips &&
            outgoingDestinationTrips.length > 0 &&
            outgoingDestinationTrips.map((itinerary, index) => {
              return this.renderTable(itinerary.trips, index);
            })}
          {incomingDestinationTrips &&
            incomingDestinationTrips.length > 0 &&
            incomingDestinationTrips.map((itinerary, index) => {
              return this.renderTable(itinerary.trips, index);
            })}
        </div>
      );
    }
  }
}

export default ItinerariesPrintable;



// WEBPACK FOOTER //
// ./src/components/Pages/Itineraries2/ItinerariesPrintable.js